var map = {
	"./aral_komfort.svg": 3264,
	"./aral_plus.svg": 3265,
	"./bp_bonus.svg": 3266,
	"./bp_komfort.svg": 3267,
	"./bp_komfort_prepaid.svg": 3268,
	"./bp_plus.svg": 3269,
	"./fuel-card-active.svg": 3270,
	"./fuel-card-inactive.svg": 3271
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3263;